export default "/static/13bbdc248f08961b.svg"